import React, { useEffect } from 'react';

import { usePathHistory } from '../utils/tracking/PathHistoryContext';
import pageNames from './pageNames';
import SubTaskContainerHeader from '../SubTaskContainerHeader';
import {
  trackSubtaskStepView,
  trackExternalLinkClick,
} from '../../utils/tracking/features/subtaskTracking';

const DisagreeFileClaimPage = () => {
  const { addStep, getHistory } = usePathHistory();

  // ──────────────────────────────────────────────
  // STEP VIEW TRACKING
  // ──────────────────────────────────────────────
  useEffect(() => {
    trackSubtaskStepView({
      stepName: pageNames.disagreeFileClaim,
      pathHistoryContext: { addStep, getHistory },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SubTaskContainerHeader title="Request a decision review" />
      <div id={pageNames.disagreeFileClaim}>
        <p className="vads-u-margin-top--0">
          If you disagree with the decision on a previously submitted claim, you
          can request a decision review.
        </p>
        <va-link
          external
          href="/decision-reviews/"
          text="Learn about the decision review process"
          onClick={() => {
            trackExternalLinkClick({
              linkLabel: 'Learn about the decision review process',
              pageName: pageNames.disagreeFileClaim,
              pathHistoryData: getHistory(),
            });
          }}
        />
      </div>
    </>
  );
};

export default {
  name: pageNames.disagreeFileClaim,
  component: DisagreeFileClaimPage,
  back: pageNames.appeals,
  next: null,
};
